import { call, delay, put, takeEvery } from "redux-saga/effects";
import Parse from "parse";
import {
  getTestByCourseError,
  getTestByCourseLoading,
  getTestByCourseSuccess,
  getTestQuestionsError,
  getTestQuestionsLoading,
  getTestQuestionsSuccess,
  getTestResultClear,
  getTestResultError,
  getTestResultLoading,
  getTestResultSuccess,
  insertTestDataError,
  insertTestDataLoading,
} from "./actions";
import {
  GET_TEST_BY_COURSE,
  GET_TEST_QUESTIONS,
  GET_TEST_RESULT,
  INSERT_TEST_DATA,
} from "./constants";
import { APP_ID } from "../../utils/helpers";

function* getTestByCourseMethod({ payload }) {
  try {
    yield put(getTestByCourseLoading());
    const { skipRecord, limit, coursePtr, parentPtr, isMerge, isNew } = payload;

    const TestQuery1 = new Parse.Query("test_TestInfo");
    TestQuery1.equalTo("Type", "Folder");

    const TestQuery2 = new Parse.Query("test_TestInfo");
    TestQuery2.notEqualTo("Type", "Folder");
    TestQuery2.equalTo("IsPublished", true);
    TestQuery2.greaterThanOrEqualTo("TestToDate", new Date());
    const mainQuery = Parse.Query.or(TestQuery1, TestQuery2);

    mainQuery.equalTo("CoursePtr", {
      __type: "Pointer",
      className: "elearning_Course",
      objectId: coursePtr,
    });
    mainQuery.equalTo(
      "ParentFolder",
      parentPtr
        ? {
            __type: "Pointer",
            className: "test_TestInfo",
            objectId: parentPtr,
          }
        : null
    );
    mainQuery.ascending("createdAt");
    // mainQuery.limit(limit);
    // mainQuery.skip(skipRecord);
    const result = yield call(() => mainQuery.find());
    if (result) {
      const resultTest = JSON.parse(JSON.stringify(result));
      yield put(getTestByCourseSuccess({ resultTest, isMerge, isNew }));
    }
  } catch (error) {
    yield put(
      getTestByCourseError(
        error?.message || "Error occurred during get test data by course."
      )
    );
  }
}

function* getTestResultMethod({ payload }) {
  try {
    const { testPtr, customerPtr } = payload;
    yield put(getTestResultLoading());
    const qodQueryList = new Parse.Query("test_TestResult");

    qodQueryList.equalTo("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });

    qodQueryList.equalTo("TestInfoPtr", {
      __type: "Pointer",
      className: "test_TestInfo",
      objectId: testPtr,
    });

    qodQueryList.equalTo("CustomerPtr", {
      __type: "Pointer",
      className: "elearning_Customer",
      objectId: customerPtr,
    });
    qodQueryList.include("TestInfoPtr");
    qodQueryList.include("TestAnsweredPtr");
    qodQueryList.descending("createdAt");
    const result = yield call(() => qodQueryList.first());
    if (result) {
      yield put(
        getTestResultSuccess({
          status: true,
          message: "You have already attempted this test..!",
        })
      );
      yield delay(5000);
      yield put(getTestResultClear());
    } else {
      yield put(getTestResultSuccess({ status: false, message: "" }));
      yield delay(5000);
      yield put(getTestResultClear());
    }
  } catch (error) {
    yield put(
      getTestResultError(
        error?.message || "Error occurred during get test result."
      )
    );
  }
}

function* getTestQuestionsMethod({ payload }) {
  try {
    yield put(getTestQuestionsLoading());
    const courseTestQuery = new Parse.Query("test_TestQueRel");

    courseTestQuery.equalTo("TestInfoPtr", {
      __type: "Pointer",
      className: "test_TestInfo",
      objectId: payload,
    });
    courseTestQuery.exists("TestQuestionsPtr");
    courseTestQuery.include("TestQuestionsPtr");
    courseTestQuery.limit(2000);
    const result = yield call(() => courseTestQuery.find());
    if (result?.length) {
      const resultTest = JSON.parse(JSON.stringify(result));
      const updateData = resultTest.filter((data) => data.TestQuestionsPtr);
      yield put(getTestQuestionsSuccess(updateData));
    }
  } catch (error) {
    yield put(
      getTestQuestionsError(
        error?.message || "Error occurred during get test questions."
      )
    );
  }
}

function* insertTestData({ payload }) {
  try {
    yield put(insertTestDataLoading());
    const date = new Date();
    const {
      testPtr,
      customerPtr,
      testDataList,
      CourseTitle,
      TestTitle,
      percentage,
      obtainedMarks,
      totalMarks,
      Status,
      custMobNo,
      custName,
    } = payload;
    const mcqTestQuery = new Parse.Object("test_TestAnswered");
    mcqTestQuery.set("AppId", {
      __type: "Pointer",
      className: "elearning_BuildConfig",
      objectId: APP_ID,
    });
    mcqTestQuery.set("CustomerPtr", {
      __type: "Pointer",
      className: "elearning_Customer",
      objectId: customerPtr,
    });
    mcqTestQuery.set("TestInfoPtr", {
      __type: "Pointer",
      className: "test_TestInfo",
      objectId: testPtr,
    });
    mcqTestQuery.set("SubmittedAnswers", testDataList);
    mcqTestQuery.set("CourseTitle", CourseTitle);
    mcqTestQuery.set("IsActive", true);
    mcqTestQuery.set("SubmitttedDateTime", date);
    mcqTestQuery.set("TestTitle", TestTitle);
    const result = yield call(() => mcqTestQuery.save());
    if (result) {
      const qodQueryList = new Parse.Query("test_TestAnswered");
      qodQueryList.equalTo("AppId", {
        __type: "Pointer",
        className: "elearning_BuildConfig",
        objectId: APP_ID,
      });
      qodQueryList.equalTo("CustomerPtr", {
        __type: "Pointer",
        className: "elearning_Customer",
        objectId: customerPtr,
      });
      qodQueryList.descending("createdAt");
      const data = yield call(() => qodQueryList.first());
      if (data) {
        const testAnswerId = data.id;
        const per = percentage?.toFixed(2);
        const changePercentage = parseFloat(per);
        let grade = "";
        if (percentage >= 90 && percentage <= 100) {
          grade = "A";
        } else if (percentage >= 85 && percentage < 90) {
          grade = "B";
        } else if (percentage >= 83 && percentage < 85) {
          grade = "C";
        } else if (percentage >= 79 && percentage < 83) {
          grade = "D";
        } else if (percentage >= 31 && percentage < 79) {
          grade = "E";
        } else if (percentage < 31) {
          grade = "F";
        }
        const testResultObject = new Parse.Object("test_TestResult");
        testResultObject.set("AppId", {
          __type: "Pointer",
          className: "elearning_BuildConfig",
          objectId: APP_ID,
        });
        testResultObject.set("CustomerPtr", {
          __type: "Pointer",
          className: "elearning_Customer",
          objectId: customerPtr,
        });
        testResultObject.set("TestInfoPtr", {
          __type: "Pointer",
          className: "test_TestInfo",
          objectId: testPtr,
        });
        testResultObject.set("TestAnsweredPtr", {
          __type: "Pointer",
          className: "test_TestAnswered",
          objectId: testAnswerId,
        });
        testResultObject.set("CustName", custName); // need to change
        testResultObject.set("CourseTitle", CourseTitle);
        testResultObject.set("TestDate", date);
        testResultObject.set("TestTitle", TestTitle);
        testResultObject.set("ObtainedMarks", obtainedMarks);
        testResultObject.set("Percentage", changePercentage);
        testResultObject.set("ResultDesc", "__");
        testResultObject.set("Status", Status); //need to change
        testResultObject.set("TotalMarks", totalMarks); // need to change
        testResultObject.set("YourGrade", grade);
        testResultObject.set("MaskedPhone", custMobNo); //need to change
        yield call(() => testResultObject.save());
      }
    }
  } catch (error) {
    yield put(
      insertTestDataError(
        error?.message || "Error occured during save test data."
      )
    );
  }
}

export default function* testSagas() {
  yield takeEvery(GET_TEST_BY_COURSE, getTestByCourseMethod);
  yield takeEvery(GET_TEST_RESULT, getTestResultMethod);
  yield takeEvery(GET_TEST_QUESTIONS, getTestQuestionsMethod);
  yield takeEvery(INSERT_TEST_DATA, insertTestData);
}
